import React from 'react';

const Experience = () => {
  const projects = [
    {
      title: "Education Mobile Application",
      role: "Lead Developer / Timeline Manager",
      desc: "Developing a comprehensive educational app focused on elementary learning in Math, English, and Science. Managed the work breakdown structure from January to April."
    },
    {
      title: "Real-time Public Vehicle Tracking",
      role: "Capstone Project Member",
      desc: "Collaborating on a digital tracking system optimized for public transportation inside Baguio City, involving detailed stakeholder analysis and Gantt chart scheduling."
    },
    {
      title: "Credit Risk  Evaluation",
      role: "Data Analyst",
      desc: "Generated a detailed Phase 4 report comparing Logistic Regression and Random Forest algorithms using ROC curves, confusion matrices, and feature importance analysis."
    }
  ];

  return (
    <section id="experience" className="my-16 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md transition-colors duration-300">
      <h2 className="text-3xl font-semibold text-blue-600 dark:text-blue-400 mb-6">Experience & Projects</h2>
      <div className="space-y-6">
        {projects.map((proj, index) => (
          <div key={index} className="p-4 border border-gray-200 dark:border-gray-700 rounded hover:shadow-lg transition-shadow">
            <h3 className="text-xl font-bold dark:text-white">{proj.title}</h3>
            <p className="text-sm font-semibold text-blue-500 dark:text-blue-400 mb-2">{proj.role}</p>
            <p className="text-gray-700 dark:text-gray-300">{proj.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;